<template>
    <div class="main">
        <MyHeader index="3"></MyHeader>
        <div class="titleIfo">
            <div class="container" v-if=" this.$i18n.locale == 'zh_CN'">
                <h2>报告</h2>
                <h3>Reports</h3>
            </div>
            <div class="container" v-if=" this.$i18n.locale == 'en_US'">
                <h2>Reports</h2>
                <h3>报告</h3>
            </div>
        </div>
        <div class="resourcesList">
            <div class="container">
                <div class="search">
                    <ul class="navList" id="menu">
                        <li class="on">{{$t('Level.International level')}}</li>
                        <li>{{$t('Level.Technical level')}}</li>
                        <li>{{$t('Level.National level')}}</li>
                    </ul>
                    <div class="searchInput">
                        <input type="text" :placeholder="$t('resources.search')" v-model="page.search_str">
                        <img src="./image/search.png" alt="search" @click="search">
                    </div>
                </div>
                <!--
                <div class="list">
                    <ul>
                        <li v-for="item in report">
                            <router-link :to="'/reportInfo/'+ item.id">
                                <div class="imgBody">
                                    <img :src="item.thumb_image" alt="resourcesImg">
                                </div>
                                <div class="textInfo">
                                    <h2>{{item.name}}</h2>
                                    <h3>
                                       {{$t('label.release')}}{{item.releaseTime}}
                                     
                                    </h3>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                    <pagination :pageInfo="pageInfo" @change="pagechange"></pagination>
                </div>
                -->
                
                <div class="rightContent">
                           <ul  v-if=" this.$i18n.locale == 'zh_CN'">
                                <li v-for="(item,i) in report">
                                    <router-link :to="{name:'reportInfo',params:{id:item.id}}">
                                        <div class="newsImg">
                                            <img :src="item.thumb_image" alt="newsImg">
                                        </div>
                                        <div class="newText">
                                            <h3 >{{item.name}}</h3>                                
    	                                    <p >{{item.brief}}</p>
                                            <h6>{{$t('label.release')}}{{item.releaseTime}}</h6>
                                            
                                        </div>
                                    </router-link>
                                </li>
                            </ul>
                            
                             <ul  v-if=" this.$i18n.locale == 'en_US'">
                                <li v-for="(item,i) in report">
                                    <router-link :to="{name:'reportInfo',params:{id:item.id}}">
                                        <div class="newsImg">
                                            <img :src="item.thumb_image" alt="newsImg">
                                        </div>
                                        <div class="newText">
                                            <h3 >{{item.name}}</h3>
                                            <p >{{item.brief}}</p>
                                            <h6>{{$t('label.release')}}{{item.releaseTime}}</h6>
                                            
                                        </div>
                                    </router-link>
                                </li>
                            </ul>
                            
                        <pagination :pageInfo="pageInfo" @change="pagechange"></pagination>
                </div>
            </div>
        </div>
        <MyFooter></MyFooter>
    </div>
</template>

<script>
    import MyHeader from './common/MyHeader'
    import MyFooter from './common/MyFooter'
    import pagination from './common/vue-pagination'
    import filter from '../filter.js';
    import {createArticle, getArticleList, getArticleDetails, deleteArticle, putArticle} from '@/services/article';

    export default {
        name: "ReportPage",
        components: { MyHeader,MyFooter ,pagination},
        data(){
            return{
                page:{
                    page_size:6,
                    page:1,
                    search_str:'',
                    category_id:72,
                    language:''
                },
                report:[],
                pageInfo:{
                    total:0,        // 记录总条数   默认空，如果小于pageNum则组件不显示   类型Number
                    current:1,      // 当前页数，   默认为1                             类型Number
                    pagenum:6,      // 每页显示条数,默认10                              类型Number
                    pagegroup:3,    // 分页条数     默认为5，需传入奇数                  类型Number
                    skin:'#13AE67'  // 选中页码的颜色主题 默认为'#16a086'                类型String
                },
            }
        },
        mounted(){
            this.getList();
        },
        methods:{
            getList(){
                if (this.$i18n.locale == 'zh_CN') {
                   
                    this.page.language = [1,2]
                } else {
                    this.$i18n.locale = 'en_US'
                    this.page.language = [1,3]
                }
                getArticleList(this.page).then(res => {
                    let list = res.items;
                    for (var i in list) {
                        let item = list[i];
                        item.releaseTime = filter.dateFormat(item.release_time,'yyyy-mm-dd');
                    }
                    
                     this.pageInfo.total= res._meta.totalCount;
                    this.pageInfo.current= res._meta.currentPage;
                    this.pageInfo.pagenum= res._meta.perPage;
                    
                    this.report = list
                }).catch();
            },
            pagechange(current){
                this.page.page = current;
                this.getList();
            },
            search(){
                this.getList();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main{
        .titleIfo{
            width: 100%;
            height:380px;
            background: url("./image/report.jpg") no-repeat center center;
            background-size: cover;
            .container{
                h2{
                    padding-top: 180px;
                    text-align: center;
                    color: #FFFFFF;
                    height:42px;
                    font-size:32px;
                    font-weight:bold;
                    line-height:42px;
                }
                h3{
                    text-align: center;
                    height:29px;
                    font-size:22px;
                    line-height:29px;
                    color: #FFFFFF;
                }
            }
        }
        .resourcesList{
            .container{
                .search{
                    padding-top: 77px;
                    border-bottom: 1px solid #E4E4E4;
                    overflow: hidden;
                    position: relative;
                    width: 1200px;
                    .navList{
                        overflow: hidden;
                        float: left;
                        height: 29px;
                        li{
                            display: none;
                            cursor: pointer;
                            float: left;
                            font-size: 14px;
                            color: #666666;
                            margin-left: 48px;
                            padding-bottom: 7px;
                            &:first-child{
                                margin-left: 0;
                            }
                        }
                        .on{
                            color: #13AE67;
                            border-bottom: 3px #13AE67 solid;
                        }
                    }
                    .searchInput{
                        position: absolute;
                        right: 0;
                        bottom: 10px;
                        z-index: 10;
                        width: 372px;
                        padding: 0 20px;
                        background-color: #F1F1F1;
                        border-radius: 36px;
                        height: 40px;
                        overflow: hidden;
                        input{
                            background-color: transparent;
                            float: left;
                            height: 40px;
                            border: none;
                            width: 346px;
                        }
                        img{
                            float: right;
                            margin-top: 12px;
                            cursor: pointer;
                        }
                    }
                }
                .list{
                    margin-top: 48px;
                    ul{
                        overflow: auto;
                        li{
                            cursor: pointer;
                            float: left;
                            width:372px;
                            margin-right: 42px;
                            margin-bottom: 40px;
                            a{
                                display: block;
                            }
                            &:nth-of-type(3n){
                                margin-right: 0;
                            }
                            .imgBody{
                                height:210px;
                                overflow: hidden;
                                img{
                                    width: 102%;
                                }
                            }
                            .textInfo{
                                height: 126px;
                                background: #34434E;
                                h2{
                                    font-size: 16px;
                                    color: #FFFFFF;
                                    width: 325px;
                                    margin: 0 auto;
                                    padding-top: 24px;
                                    line-height:22px;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 2;
                                    overflow: hidden;
                                    height: 44px;
                                }
                                h3{
                                    width: 325px;
                                    margin: 16px auto 0;
                                    color: #7B8389 ;
                                    font-size: 12px;
                                    i{
                                        &:after{
                                            content: '  ｜  ';
                                        }
                                    }
                                    b{}
                                }
                            }
                        }
                    }
                }
                
                .rightContent{
                      
                        margin-top:15px;
                        ul{
                            li{
                                margin-bottom: 40px;
                                &:last-child{
                                    margin-bottom: 32px;
                                }
                                a{
                                    overflow: hidden;
                                    display: block;
                                    .newsImg{
                                        float: left;
                                        width: 216px;
                                        height: 144px;
                                        img{
                                            width: 100%;
                                        }
                                    }
                                    .newText{
                                        float: left;
                                        margin-left: 20px;
                                        width: 584px;
                                        h3{
                                            margin-top: 0px;
                                            color: #252525;
                                            height:24px;
                                            font-size:18px;
                                            font-weight:bold;
                                            line-height:24px;
                                        }
                                        p{
                                            display: block;
                                            font-size: 14px;
                                            color: #505050;
                                            line-height: 20px;
                                            height: 60px;
                                            margin-top: 22px;
                                            display: -webkit-box;
                                            -webkit-box-orient: vertical;
                                            -webkit-line-clamp: 3;
                                            overflow: hidden;
                                        }
                                        h6{
                                            margin-top: 22px;
                                            height:12px;
                                            font-size:12px;
                                            color:#A0A0A0;
                                            line-height:12px;
                                        }
                                    }
                                }
                            }
                        }
                    }
            }
        }
    }
</style>
